export default "Raw HTML syntax can be used:\n<p>\nMarkdown _inside_ HTML inside markdown is **not** so reliable.\nHTML tags <em>are</em>, though.\n</p>";